import { render, staticRenderFns } from "./related-information.vue?vue&type=template&id=b58ee4c0&scoped=true"
import script from "./related-information.vue?vue&type=script&lang=js"
export * from "./related-information.vue?vue&type=script&lang=js"
import style0 from "./related-information.vue?vue&type=style&index=0&id=b58ee4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58ee4c0",
  null
  
)

export default component.exports